import type { GeneratedPackageSettings } from './PackageSettings.js';

/**
 * Per-application generated configuration for Cloudpack.
 */
export interface GeneratedConfig {
  /**
   * Generated settings to correct issues with packages or optimize their bundling process.
   */
  packageSettings?: GeneratedPackageSettings[];
}
